<template>
    <v-form>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
                v-model="item.name"
                :error-messages="nameErrors"
                :label="$t('global.name')"
                required
                @input="$v.item.name.$touch()"
                @blur="$v.item.name.$touch()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
                v-model.number="item.quality"
                :error-messages="qualityErrors"
                :label="$t('order.quality')"
                required
                @input="$v.item.quality.$touch()"
                @blur="$v.item.quality.$touch()"
            />
          </v-col>
        </v-row>
  
      </v-container>
    </v-form>
  </template>
  
  <script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  
  export default {
    name: 'OrderResolutionForm',
    mixins: [validationMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
  
      errors: {
        type: Object,
        default: () => {}
      },
  
      initialValues: {
        type: Object,
        default: () => {}
      }
    },
    mounted() {
    },
    data() {
      return {
        name: null,
        quality: null,
      };
    },
    computed: {
  
      // eslint-disable-next-line
      item() {
        return this.initialValues || this.values;
      },
  
      nameErrors() {
        const errors = [];
  
        if (!this.$v.item.name.$dirty) return errors;
  
        has(this.violations, 'name') && errors.push(this.violations.name);
  
        !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
  
        return errors;
      },
      qualityErrors() {
        const errors = [];
  
        if (!this.$v.item.quality.$dirty) return errors;
  
        has(this.violations, 'quality') && errors.push(this.violations.quality);
  
        !this.$v.item.quality.required && errors.push(this.$t('global.field_required'));
  
        return errors;
      },
      
  
      violations() {
        return this.errors || {};
      }
    },
    methods: {
    },
    validations: {
      item: {
        name: {
          required,
        },
        quality: {
            required
        }
      }
    }
  };
  </script>
  